/**
 * Provides AppInsights instance to any component.
 */
import { AppInsightsContext, useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { useSession } from 'next-auth/react';
import { PropsWithChildren, memo, useEffect } from 'react';

import { appInsightsInstance, reactPlugin } from './appInsightsInstance';

export { useAppInsightsContext };

export const AppInsightsPluginProvider = memo(({ children }: PropsWithChildren) => {
	const session = useSession();

	useEffect(() => {
		if (session.status === 'authenticated') {
			appInsightsInstance.setAuthenticatedUserContext(
				session.data.user.email,
				session.data.user.email,
				true,
			);
		}
	}, [session]);

	return <AppInsightsContext value={reactPlugin}>{children}</AppInsightsContext>;
});

AppInsightsPluginProvider.displayName = 'AppInsightsPluginProvider';
